<h1 class="title">{{'MAILERS.TITLE' | translate}}</h1>

<div style="max-width: 980px; margin: 0 auto; padding: 32px;">
    <mat-card>
        <mat-card-content>
            <vzn-data-table #table [restService]="logService" [pageSize]="25" [columns]="columns" [query]="query"
                [mapper]="logMapper"
                [allowImport]="false"
                [allowExport]="true">
            </vzn-data-table>
        </mat-card-content>
    </mat-card>
    <mat-card>
        <h2>{{'LOG-TABLE.DELETE_EMAIL_LOGS' | translate}}</h2>
        <ng-container *ngIf="emailList">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
                <mat-form-field fxFlex="250px">
                    <input [formControl]="emailToDelete" matInput [matAutocomplete]="auto" placeholder="">
                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="emailDisplay">
                        <mat-option *ngFor="let email of emailList" [value]="email">
                        {{ email.name }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <button mat-raised-button color="warn" (click)="deleteEmailLogs()">{{ 'MAIN-APP.DELETE' | translate }}</button>
            </div>
        </ng-container>
    </mat-card>
</div>

